import { Base, toast } from '@itsrever/design-system'
import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useFlagForReview } from '@/hooks/use-flag-for-review'

const {
  Button,
  DialogRoot,
  DialogTrigger,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogTitle,
  DialogDescription,
  DialogClose,
  DialogFooter,
  Textarea,
  DialogCloseButton,
  DialogHeader
} = Base

export const FlagForReview = () => {
  const { t } = useTranslation()

  const { id: processId } = useParams()

  const [open, setOpen] = useState(false)

  const { mutate, isPending } = useFlagForReview()

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!processId) return

    const formData = new FormData(e.currentTarget)
    const note = formData.get('note') as string

    mutate(
      { processId: processId, note: note },
      {
        onSuccess: () => {
          toast({
            variant: 'success',
            text: t('process_details_page.flag_for_review_success')
          })
          setOpen(false)
        },
        onError: () => {
          toast({
            variant: 'error',
            text: t('process_details_page.flag_for_review_error')
          })
        }
      }
    )
  }

  return (
    <DialogRoot open={open} onOpenChange={setOpen}>
      <DialogTrigger render={<Button variant="secondary" size="sm" />}>
        <svg
          width="14px"
          height="14px"
          strokeWidth="2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          color="currentColor"
        >
          <path
            d="M5 15L5.95039 4.54568C5.97849 4.23663 6.23761 4 6.54793 4H20.343C20.6958 4 20.9725 4.30295 20.9405 4.65432L20.0496 14.4543C20.0215 14.7634 19.7624 15 19.4521 15H5ZM5 15L4.4 21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        {t('process_details_page.flag_for_review_title')}
      </DialogTrigger>
      <DialogPortal>
        <DialogBackdrop />
        <DialogPopup>
          <div className="flex size-full w-[26rem] flex-col">
            <DialogCloseButton />
            <DialogHeader>
              <DialogTitle>
                {t('process_details_page.flag_for_review_title')}
              </DialogTitle>
              <DialogDescription>
                {t('process_details_page.flag_for_review_description')}
              </DialogDescription>
            </DialogHeader>
            <form className="space-y-4 pt-4" onSubmit={onSubmit}>
              <div className="space-y-1.5">
                <label className="inline-block text-sm" htmlFor="reason">
                  {t('process_details_page.flag_for_review_reason')}
                </label>
                <Textarea
                  id="note"
                  name="note"
                  placeholder={t(
                    'process_details_page.flag_for_review_reason_placeholder'
                  )}
                  maxLength={256}
                  className="h-20 resize-none"
                />
              </div>
              <DialogFooter className="mt-auto">
                <DialogClose
                  render={<Button variant="secondary" type="button" />}
                >
                  {t('process_details_page.flag_for_review_cancel')}
                </DialogClose>
                <Button type="submit" variant="primary" loading={isPending}>
                  {t('process_details_page.flag_for_review_submit')}
                </Button>
              </DialogFooter>
            </form>
          </div>
        </DialogPopup>
      </DialogPortal>
    </DialogRoot>
  )
}
